import React, { Component } from 'react';
import { withRouter } from 'react-router'

import { withItemsIntellegence } from '../../../shared/containers/containerItemsIntellegence'
import { withDashboards } from './../../../shared/containers/containerDashboards'
import { withSensors } from './../../../shared/containers/containerSensors'

import ButtonPrimary from '../../../shared/items/contols/buttonPrimary'
import TimeMomentIntellegence from './timeMomentIntellegence'
import getDates from './../../../shared/services/date.service'
import Notification from './../../../shared/items/static/notification'
import SnackbarWrapper from './../../../shared/items/static/snackbarWrapper'

import { states } from './../../../reducers/queriesStates'

import styles from './carsIntellegence.module.scss'

class IntellegenceMomentForm extends Component {
  constructor() {
    super();

    this.getInmomentIntelligence = this.getInmomentIntelligence.bind(this)
    this.getSensors = this.getSensors.bind(this)
  }

  componentDidMount() {
    const { dashboardsDataState, onGetDashboards } = this.props

    if (dashboardsDataState !== states.READY)
      onGetDashboards()
  }

  componentDidUpdate(prevProps) {
    const { dashboardsDataState, sensorsDataState } = this.props

    if (dashboardsDataState === states.READY && prevProps.dashboardsDataState === states.REQUEST)
      if (sensorsDataState !== states.READY && sensorsDataState !== states.REQUEST)
        this.getSensors()
  }

  getInmomentIntelligence() {
    const { onGetDashboards, dashboardsDataState } = this.props

    if (dashboardsDataState !== states.READY) {
      onGetDashboards()
    }
    else {
      this.getSensors()
    }
  }

  getSensors() {
    const {
      match,
      momentDate,
      momentTime,
      onGetSensors
    } = this.props

    let date = new Date(momentDate)
    let dateTime = new Date(momentTime)
    date.setHours(dateTime.getHours())
    date.setMinutes(dateTime.getMinutes())
    date.setSeconds(0)

    onGetSensors(match.params.id, date)
  }

  render() {
    const {
      onHandleChangeStore,
      momentDate,
      momentTime
    } = this.props

    const date = getDates.getNullTimeDateUtcNumber(momentDate)
    const currentDate = getDates.getNullTimeDateUtcNumber(new Date())
    let currentTime = new Date()
    currentTime.setSeconds(0)
    currentTime.setMilliseconds(0)

    const isValidTime =
      date === currentDate
      && getDates.setDateToUtcNumber(momentTime) > getDates.setDateToUtcNumber(currentTime)

    const isButtonDisabled =
      !momentDate
      || !momentTime
      || isNaN(momentDate)
      || isNaN(momentTime)
      || date > currentDate
      || isValidTime

    return (
      <div className={styles.container_itemsTimeIntellegence}>
        <TimeMomentIntellegence
          onHandleChangeStore={onHandleChangeStore}
          valueStore={this.props}
        />
        <div className={styles.container_itemsTimeButtom}>
          <ButtonPrimary
            handleClick={this.getInmomentIntelligence.bind(this)}
            title="Показать"
            disabled={isButtonDisabled}
          />
        </div>
        <SnackbarWrapper isOpen={isValidTime}>
          <Notification type="error">
            <p>{`Вы выбрали время (${getDates.getTimeFormat1(momentTime)}) позже текущего (${getDates.getTimeFormat1(new Date())}).`}</p>
          </Notification>
        </SnackbarWrapper>
      </div>
    )
  }
}

export default withDashboards(withSensors(withItemsIntellegence(withRouter(IntellegenceMomentForm))))